import { call, put, select } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as FeriadosActions } from "../ducks/feriados";
import { Creators as ModalActions } from "../ducks/modal";
import { Creators as AlertActions } from "../ducks/alert";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as SuccessActions } from "../ducks/success";
import { Creators as LoadingActions } from "../ducks/loading";
import { Creators as PageActions } from "../ducks/pages";
import moment from "moment";

export function* getListFeriados() {
  try {
    yield put(LoadingActions.setLoading());
    const { page, rowsPerPage, filter } = yield select(state => state.feriados);
    const { data } = yield call(
      api.post,
      `/holidays/filter?page=${page + 1}&&per_page=${rowsPerPage}`,
      filter
    );
    const { data: feriados, total } = data;
    let feriadosPayload = [];
    feriadosPayload = feriados.map(feriado => ({
      id: feriado.id,
      name: feriado.name,
      date: feriado.date ? moment(feriado.date).format("DD/MM/YYYY") : ""
    }));
    const name = "Feriados";
    const path = "feriados";
    yield put(PageActions.setPage(name, path));
    yield put(FeriadosActions.getListFeriadosSuccess(feriadosPayload, total));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getFeriados({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const { data } = yield call(api.get, `/holidays/${payload.id}`);
    data.date = data.date ? moment(data.date).format("DD/MM/YYYY") : "";
    yield put(FeriadosActions.getFeriadosSuccess(data));
    const { action } = yield select(state => state.feriadosStores);
    if (action === "EDIT" || action === "DETAIL") {
      yield put(ModalActions.open());
    } else {
      const title = "Aviso de exclusão";
      const body = `O cadastro "${data.name}" será excluido do sistema.`;
      yield put(AlertActions.openAlert(title, body));
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* editFeriados({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.put, `/holidays/${payload.id}`, payload);
    yield put(FeriadosActions.getListFeriados());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro editado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
    yield put(LoadingActions.unsetLoading());
  }
}

export function* addFeriados({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/holidays`, payload);
    yield put(FeriadosActions.searchFeriados({}));
    yield put(FeriadosActions.getListFeriados());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro adicionado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* deleteFeriados() {
  try {
    yield put(LoadingActions.setLoading());
    const { id } = yield select(state => state.feriados.item);
    yield call(api.delete, `/holidays/${id}`);
    yield put(FeriadosActions.getListFeriados());
    yield put(SuccessActions.openSuccess("Cadastro excluído com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* searchFeriados() {
  try {
    yield put(FeriadosActions.getListFeriados());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* getListFeriadosSelects() {
  try {
    const { data: feriados } = yield call(api.get, `/holidays/select`);
    yield put(FeriadosActions.getListFeriadosSuccessSelects(feriados));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* deleteAllFeriados({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/holidays/destroy-many`, {
      holidays_id: payload.selected
    });
    yield put(FeriadosActions.getListFeriados());
    yield put(SuccessActions.openSuccess("Cadastros excluídos com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/feriados.js